import React from 'react';
import { CTABand } from '../../components/CTABand';
export function MartialArtsNearMeFinalCTA() {
  return <CTABand headline="Find Storm Taekwondo Near You" copy="24786 Crestview, Farmington Hills, MI 48335 — Storm serves families across Southeast Michigan." data-id="element-2455" />;
}